import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {Subscription} from 'rxjs';

import {ExgMapDataLayerManagerService} from '../services';
import DataOptions = google.maps.Data.DataOptions;

let layerId = 0;

@Component({
  selector: 'exg-map-data-layer',
  template: ''
})
export class ExgMapDataLayerComponent implements OnInit, OnDestroy, OnChanges {
  private static _dataOptionsAttributes = ['style'];

  private _addedToManager = false;
  private _id: string = (layerId++).toString();
  private _subscriptions: Subscription[] = [];

  /**
   * This event is fired when a feature in the layer is clicked.
   */
  @Output() layerClick: EventEmitter<google.maps.Data.MouseEvent> = new EventEmitter<google.maps.Data.MouseEvent>();

  /**
   * The geoJson to be displayed
   */
  @Input() geoJson: object | string | null = null;

  /**
   * The layer's style function.
   */
  @Input() style!: (param: google.maps.Data.Feature) => google.maps.Data.StyleOptions;

  constructor(private _manager: ExgMapDataLayerManagerService) {
  }

  ngOnInit(): void {
    if (this._addedToManager) {
      return;
    }
    this._manager.addDataLayer(this);
    this._addedToManager = true;
    this._addEventListeners();
  }

  private _addEventListeners(): void {
    const listeners = [
      {name: 'click', handler: (ev: google.maps.Data.MouseEvent) => this.layerClick.emit(ev)},
    ];
    listeners.forEach((obj) => {
      // @ts-ignore
      const os = this._manager.createEventObservable(obj.name, this).subscribe(obj.handler);
      this._subscriptions.push(os);
    });
  }

  /** @internal */
  id(): string {
    return this._id;
  }

  /** @internal */
  toString(): string {
    return `ExgMapDataLayer-${this._id.toString()}`;
  }

  /** @internal */
  ngOnDestroy(): void {
    this._manager.deleteDataLayer(this);
    // unsubscribe all registered observable subscriptions
    this._subscriptions.forEach(s => s.unsubscribe());
  }

  /** @internal */
  ngOnChanges(changes: SimpleChanges): void {
    if (!this._addedToManager) {
      return;
    }

    // tslint:disable-next-line: no-string-literal
    const geoJsonChange = changes['geoJson'];
    if (geoJsonChange) {
      this._manager.updateGeoJson(this, geoJsonChange.currentValue);
    }
    const dataOptions = ExgMapDataLayerComponent._dataOptionsAttributes.reduce<google.maps.Data.DataOptions>((options, k) =>
      // @ts-ignore
      options[k] = changes.hasOwnProperty(k) ? changes[k].currentValue : (this as any)[k], {});

/*    new google.maps.Data.DataOptions
    this._manager.setDataOptions(this, dataOptions);*/
  }
}
